import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { getExternalWagerSchema, postExternalWagerSchema, putExternalWagerSchema } from './externalPlayerWager.js';

export const postExternalWagerRequest = z
  .object({
    response: postExternalWagerSchema,
  })
  .transform(({ response }) => ({ data: response }));

export const getExternalWagerRequest = z
  .object({
    ownWager: getExternalWagerSchema,
  })
  .transform(({ ownWager }) => ({ data: ownWager }));

export const putExternalWager = {
  parse: (data: unknown): undefined => {
    putExternalWagerSchema.parse(data);
    return undefined;
  },
} as const;

export const postExternalWager = {
  parse: (data: unknown) => z.union([postExternalWagerRequest, apiErrorSchema]).parse(data),
} as const;
